<app-page-header title="Promotion Details" description="Manage the media, pricing and range details for a single promotion."></app-page-header>
<div><p class="nav_id">promotions > <u>promotion-details</u></p></div>
 
<div [ngClass]="{ 'hidden': detailsLoading, 'visible': !detailsLoading }" id="promotion-header"><dx-button id="back-button" icon="arrowleft" [width]="32" [height]="32"(click)="returnToPlanning($event)"></dx-button> <p><b>{{promoType}}</b></p></div>

<div class="promoDetailsGrid" >
    <dx-data-grid #promoDetailsGrid [ngClass]="{ 'hidden': detailsLoading, 'visible': !detailsLoading }"
        [dataSource]="dataSource"
        [remoteOperations]="false"
        [rowAlternationEnabled]="true"
        [focusedRowEnabled]="true"
        [wordWrapEnabled]="true"
        [height]="'100%'"
        [width]="'100%'"
        [columnAutoWidth]="true"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [columnResizingMode]="'widget'"
        [loadPanel]="{ enabled: false }"
        (onEditorPreparing)="onEditorPreparing($event)"
        >
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="showFilterRow" [applyFilter]="true"></dxo-filter-row>
        <dxo-column-chooser
            #columnChooser
            [enabled]="true"
            mode="select"
        >
            <dxo-position
            my="right top"
            at="right bottom"
            of=".dx-datagrid-column-chooser-button"
        ></dxo-position>
        </dxo-column-chooser>
        <dxo-state-storing
            [enabled]="true"
            type="localStorage"
            storageKey="promotionDetailsState"
        ></dxo-state-storing>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-editing
            mode="batch"
            refreshMode="full"
            [allowAdding]="allowEditing"
            [allowUpdating]="allowEditing"
            [allowDeleting]="allowEditing"
        ></dxo-editing>
        <dxo-toolbar>
            <dxi-item location="before">
            <div *dxTemplate>
                <div class="joyride-target-inline" joyrideStep="details-save" stepPosition="bottom"
                  [title]="'Save your changes'" [text]="'Once you\'ve added products and set allowances, click here to save.'">
                  <dx-button icon="save" hint="Save" [disabled]="disabled" (onClick)="saveDetails()"></dx-button>
                </div>
            </div>
            </dxi-item>
            <dxi-item  location="after">
            <div *dxTemplate>
            <dx-button class="search-toggle"
            icon="search"
            [class.active]="showFilterRow"
            (onClick)="toggleFilterRow()">
            </dx-button>
            </div>
            </dxi-item>
            <dxi-item name="groupPanel"></dxi-item>



            <!-- <dxi-item name="revertButton"></dxi-item> -->
            <dxi-item name="columnChooserButton"></dxi-item>
            <dxi-item location="after">
            <div *dxTemplate>
                <div class="joyride-target-inline" joyrideStep="details-add-product" stepPosition="bottom"
                  [title]="'Add products'" [text]="'Search and add the products included in this promotion.'">
                  <dx-button icon="plus" hint="Add Product" [disabled]="disabled" (onClick)="openProductSelection($event)"></dx-button>
                </div>
            </div>
            </dxi-item>
            <dxi-item location="after">
            <div *dxTemplate>
                <div class="joyride-target-inline" joyrideStep="details-update-costs" stepPosition="bottom"
                  [title]="'Recalculate costs'" [text]="'After setting allowances and rebates, use this to recalculate product costs.'">
                  <dx-button icon="money" hint="Update Costs" [disabled]="disabled" (onClick)="updateCosts()"></dx-button>
                </div>
            </div>
            </dxi-item>
            <dxi-item name="exportButton"></dxi-item>
            <dxi-item location="after">
            <div *dxTemplate>
                <dx-button icon="help" hint="Take a Tour" (onClick)="startDetailsTour()"></dx-button>
            </div>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxi-column dataField="product_code" dataType="string" caption="Product Code" [allowEditing]="false" [fixed]="true"></dxi-column>
        <dxi-column dataField="product_name" dataType="string"  caption="Product Name" [allowEditing]="false" [fixed]="true"></dxi-column>
        <dxi-column dataField="warehouse_name" dataType="string" caption="Warehouse" [allowEditing]="false" [fixed]="true"></dxi-column>
        <dxi-column dataField="supplier_name" dataType="string" caption="Supplier" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="carton_quantity" dataType="number" caption="Carton" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="packs_per_carton" dataType="number" caption="Packs" [allowEditing]="false"></dxi-column>
        <div *dxTemplate="let data of 'rebateTemplate'">
            Rebates
            <dx-button class="edit_button promotion_status_button" icon="rename" hint="Edit Promotion Rebates" (onClick)="rebatePopupEvent($event)"></dx-button>
        </div>
        <dxi-column caption="Rebates" alignment="center" headerCellTemplate="rebateTemplate">
            <ng-container *ngFor="let column of columns">
            <dxi-column
                [dataField]="column.dataField"
                [name]="column.dataField"
                [format]="currencyFormat"
                [dataType]="column.dataType"
                [allowEditing]="true"
                [setCellValue]="column.setCellValue">
            </dxi-column>
            </ng-container>
            <dxi-column dataField="rebate" dataType="number" [format]="currencyFormat" [allowEditing]="false" caption="Rebate Total"></dxi-column>
            <dxi-column dataField="max_rebate_qty" dataType="number" caption="Max Rebate Qty"></dxi-column>
        </dxi-column>
        <dxi-column dataField="allowance" [format]="currencyFormat" dataType="number" caption="Allowance" [setCellValue]="setAllowanceTotal"></dxi-column>
        <dxi-column dataField="allowance_group" [format]="currencyFormat" dataType="number" visible="false" [allowEditing]="false" caption="Allowance Group"></dxi-column>
        <dxi-column dataField="allowance_promotion" [format]="currencyFormat" dataType="number" visible="false" [allowEditing]="false" caption="Allowance Promotion"></dxi-column>
        <dxi-column dataField="allowance_total" [format]="currencyFormat" dataType="number" caption="Allowance Total" [setCellValue]="setAllowance" [calculateCellValue]="calculateAllowanceTotal"></dxi-column>
        <dxi-column dataField="new_cost" [format]="currencyFormat" caption="New Cost" [calculateCellValue]="calculateNewCost" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="cost_inc_wet_only" [format]="currencyFormat" dataType="number" caption="Std Cost"  [allowEditing]="false"></dxi-column>
        <dxi-column dataField="comment" dataType="string" caption="Comment" [visible]="false"></dxi-column>
    

        <dxo-summary>
            <dxi-group-item column="product_group_name" summaryType="count"> </dxi-group-item>
        </dxo-summary>
    </dx-data-grid>

<!--Promotion Rebates Setup-->
<dx-popup
  [(visible)]="promotionRebatesPopup.editPromotionRebates"
  [hideOnOutsideClick]="true"
  [showTitle]="true"
  title="Promotion Rebates"
  height="50%"
  width="400px"
  [showCloseButton]="true"
  (onHiding)="promotionRebatesPopup.onHiding($event)">
    <app-promotion-rebates #promotionRebatesPopup (loadParentData)="loadData()"></app-promotion-rebates>
</dx-popup>

<!--Product Selection-->
<dx-popup #productSelection
  [hideOnOutsideClick]="true"
  [showTitle]="true"
  title="Select Products"
  height="75%"
  width="70%"
  [showCloseButton]="true">
    <app-product-selection (loadParentData)="loadData()" (closeChild)="closeProductSelection()" [parent]="parent" [excludeProductIds]="existingProductIds"></app-product-selection>
</dx-popup>



<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="detailsLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
>
</dx-load-panel>
